export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9526.80b0eb92.jpg";